import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Flip command
 *
 * @class FlipItemCommand
 * @extends AbstractCommand
 */
export default class FlipItemCommand extends AbstractCommand {
    constructor(items) {
        super();
        this.items = items;
        this.initialFlipState = {};

        this.items.forEach(item => (this.initialFlipState[item.cid] = item.get('flipped')));
    }

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        return !this.items.find(item => !item.supportsFlipping || !item.get('allowFlipping'));
    }

    /**
     * Execute command
     */
    execute() {
        if (!this.isValid()) return;

        this.items.forEach(item => item.set('flipped', !this.initialFlipState[item.cid]));
    }

    /**
     * Unexecute command
     */
    unexecute() {
        if (!this.isValid()) return;

        this.items.forEach(item => item.set('flipped', this.initialFlipState[item.cid]));
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        let title = 'Flip ';

        if (this.items.length === 1) {
            title += this.items[0].attributes.type;
        } else {
            title += `${this.items.length} objects`;
        }

        return title;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.FlipItemCommand = FlipItemCommand;
